module.exports = __webpack_public_path__ + "static/media/rocket_white-01.4012f615.svg";